import { render, staticRenderFns } from "./Rattachment.vue?vue&type=template&id=765d1324"
import script from "./Rattachment.vue?vue&type=script&lang=js"
export * from "./Rattachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports